<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="球杆解绑"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <!-- 独立的背景图区域 -->
      <div class="bg-card">
        <img src="@/assets/img/h5/unbind.png" alt="背景图" class="bg-img" />
      </div>

      <!-- 新增：解绑主要提示文字 -->
      <div class="main-tip">仅支持会员退货解绑</div>

      <!-- 独立的文本框区域（放在背景图下方） -->
      <div class="form-card">
        <!-- 球杆编码输入框 -->
        <van-field
            v-model="number"
            name="number"
            label="球杆编码"
            placeholder="请输入球杆编码"
            class="form-input number-input"
            required
            @blur="trimNumber"
        />
        <!-- 解绑原因 textarea 文本框 -->
        <van-field
            v-model="opinion"
            required
            name="opinion"
            label="解绑原因"
            type="textarea"
            placeholder="请输入解绑原因"
            class="form-input reason-input"
            rows="3"
            @blur="trimOpinion"
        />
      </div>

      <!-- 解绑按钮（在文本框下方） -->
      <van-button class="search-btn" block @click="getProgress">解绑</van-button>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {unbindByNumber, updatePasswordToVerify} from "@/api/sales";
import {Dialog, Toast} from "vant";

export default {
  data() {
    return {
      number: '', // 球杆编码
      opinion: '', // 解绑原因
    }
  },
  methods: {
    // 顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },

    showDialogMsg(message) {
      Dialog.alert({
        title: '提示',
        message: message,
      });
    },
    // 球杆编码去空格
    trimNumber() {
      this.number = this.number.trim();
    },
    // 解绑原因去空格
    trimOpinion() {
      this.opinion = this.opinion.trim();
    },
    // 球杆解绑（解绑原因非空校验）
    getProgress() {
      this.trimNumber(); // 球杆编码去空格
      this.trimOpinion(); // 解绑原因去空格

      // 1. 校验球杆编码
      if (!this.number) {
        Toast('请输入球杆编码');
        return;
      }
      // 2. 校验解绑原因
      if (!this.opinion) {
        Toast('请输入解绑原因');
        return;
      }

      // 确认弹窗
      Dialog.confirm({
        title: '确认解绑',
        message: '是否确认解绑该球杆？解绑后将解除该球杆编码的绑定关系，请谨慎操作！',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.doUnbind();
      }).catch(() => {
      });
    },
    // 解绑核心逻辑（传递解绑原因参数）
    async doUnbind() {
      // 构造接口参数：包含球杆编码和解绑原因
      const params = {
        keyWord: this.number,
        opinion: this.opinion
      };
      const res = await unbindByNumber(params);
      if (res.code === 200) {
        this.showDialogMsg(res.returnMsg || '球杆解绑成功！');
        // 解绑成功后清空所有输入
        this.number = '';
        this.opinion = '';
      } else {
        this.showDialogMsg(res.returnMsg || '球杆解绑失败，请稍后重试');
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 导航栏样式
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}

// 整体容器
.container-item {
  padding: 0 16px;
  margin-bottom: 60px;
}

// 独立背景图区域
.bg-card {
  margin: 16px 0;
  border-radius: 12px;
  overflow: hidden; // 防止图片超出圆角
  // 新增：背景图边框样式（和页面主色调匹配的金色边框）
  border: 2px solid #B8860B;
  box-sizing: border-box; // 保证边框不会超出圆角容器
}
.bg-img {
  width: 100%;
  height: auto; // 自适应高度，保持图片比例
  display: block; // 去掉图片默认间隙
}

// 新增：主要提示文字样式
.main-tip {
  text-align: center;
  color: #B8860B;
  font-size: 15px;
  font-weight: bold;
  margin: 0 0 12px;
  line-height: 1.4;
}

// 独立文本框区域
.form-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05); // 轻微阴影提升质感
}
.form-input {
  border-radius: 10px;
  border-bottom: none;
  background: #f8f8f8;
}
.number-input {
  margin-bottom: 15px; // 编码和原因输入框之间的间距
}
.reason-input {
  background: #f8f8f8;
}

// 解绑按钮样式
.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
}

// 弹窗按钮样式适配
::v-deep .van-dialog__confirm {
  color: #B8860B !important;
}
</style>